import React from 'react';
import {
  Menu, X, ChevronRight, ChevronLeft, ChevronDown, ChevronUp,
  ArrowRight, ArrowLeft, ArrowUpRight, ExternalLink, Plus, Minus, Check,
  Search, Settings, Bell, User, Users, LogOut, HelpCircle,
  Package, Box, Truck, Plane, Ship, MapPin, Map, Route, Globe, Scale, Ruler,
  Wallet, CreditCard, ReceiptText, DollarSign, Tag,
  File, Copy, Edit, Trash2, Download, Upload, Mail, Phone,
  Clock, CheckCircle, AlertCircle, AlertTriangle, Info, Shield, Sparkles, Zap, Star,
  Grid3x3, List, Filter, ArrowDownUp, Calendar, RefreshCw, Eye, Lock, Key,
  Gift, Building, Wrench, Code, Terminal, Bot, Send, Compass, Layers, Home,
  TrendingUp, Activity, MoreHorizontal, Barcode, QrCode, Warehouse, Languages,
  Sun, Moon, Paperclip,
  type LucideIcon,
} from 'lucide-react';

export type IconName =
  | 'menu' | 'x' | 'chevronRight' | 'chevronLeft' | 'chevronDown' | 'chevronUp'
  | 'arrowRight' | 'arrowLeft' | 'arrowUpRight' | 'external' | 'plus' | 'minus' | 'check'
  | 'search' | 'settings' | 'bell' | 'user' | 'users' | 'logout' | 'help'
  | 'package' | 'box' | 'truck' | 'plane' | 'ship' | 'mapPin' | 'map' | 'route' | 'globe' | 'scale' | 'ruler'
  | 'wallet' | 'card' | 'receipt' | 'dollar' | 'tag'
  | 'file' | 'copy' | 'edit' | 'trash' | 'download' | 'upload' | 'mail' | 'phone'
  | 'clock' | 'checkCircle' | 'alertCircle' | 'alert' | 'info' | 'shield' | 'sparkle' | 'zap' | 'star'
  | 'grid' | 'list' | 'filter' | 'sort' | 'calendar' | 'clock2' | 'refresh' | 'eye' | 'lock' | 'key'
  | 'gift' | 'building' | 'tool' | 'code' | 'terminal' | 'bot' | 'send' | 'compass' | 'layers' | 'home'
  | 'trendingUp' | 'activity' | 'moreHoriz' | 'barcode' | 'qr' | 'warehouse' | 'language'
  | 'sun' | 'moon' | 'paperclip';

const REGISTRY: Record<IconName, LucideIcon> = {
  menu: Menu, x: X, chevronRight: ChevronRight, chevronLeft: ChevronLeft, chevronDown: ChevronDown, chevronUp: ChevronUp,
  arrowRight: ArrowRight, arrowLeft: ArrowLeft, arrowUpRight: ArrowUpRight, external: ExternalLink, plus: Plus, minus: Minus, check: Check,
  search: Search, settings: Settings, bell: Bell, user: User, users: Users, logout: LogOut, help: HelpCircle,
  package: Package, box: Box, truck: Truck, plane: Plane, ship: Ship, mapPin: MapPin, map: Map, route: Route, globe: Globe, scale: Scale, ruler: Ruler,
  wallet: Wallet, card: CreditCard, receipt: ReceiptText, dollar: DollarSign, tag: Tag,
  file: File, copy: Copy, edit: Edit, trash: Trash2, download: Download, upload: Upload, mail: Mail, phone: Phone,
  clock: Clock, checkCircle: CheckCircle, alertCircle: AlertCircle, alert: AlertTriangle, info: Info, shield: Shield, sparkle: Sparkles, zap: Zap, star: Star,
  grid: Grid3x3, list: List, filter: Filter, sort: ArrowDownUp, calendar: Calendar, clock2: Clock, refresh: RefreshCw, eye: Eye, lock: Lock, key: Key,
  gift: Gift, building: Building, tool: Wrench, code: Code, terminal: Terminal, bot: Bot, send: Send, compass: Compass, layers: Layers, home: Home,
  trendingUp: TrendingUp, activity: Activity, moreHoriz: MoreHorizontal, barcode: Barcode, qr: QrCode, warehouse: Warehouse, language: Languages,
  sun: Sun, moon: Moon, paperclip: Paperclip,
};

export type IconProps = {
  name: IconName;
  size?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
  style?: React.CSSProperties;
  'aria-label'?: string;
};

export const Icon: React.FC<IconProps> = ({
  name,
  size = 18,
  color = 'currentColor',
  strokeWidth = 1.75,
  className,
  style,
  'aria-label': ariaLabel,
}) => {
  const Cmp = REGISTRY[name];
  if (!Cmp) return null;
  return (
    <Cmp
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      className={className}
      style={style}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
    />
  );
};
